export { CarAIBanner, type CarAIBannerProps } from './CarAIBanner';
export {
  CarAIBannerMobile,
  type CarAIBannerMobileProps,
} from './CarAIBannerMobile';
